import React, { useState, useEffect } from 'react';

// Döviz Kur Ayarları Bileşeni (Performans için dışarıya taşındı ve memoize edildi)
const ExchangeRateSettings = React.memo(({ initialSettings, exchangeRates, onSave }) => {
  const [useManual, setUseManual] = useState(initialSettings.useManualRates);
  const [usd, setUsd] = useState(initialSettings.manualUsdRate);
  const [eur, setEur] = useState(initialSettings.manualEurRate);
  const [localIsSaving, setLocalIsSaving] = useState(false);

  // Initial değerler değişirse senkronize et
  useEffect(() => {
    setUseManual(initialSettings.useManualRates);
    setUsd(initialSettings.manualUsdRate);
    setEur(initialSettings.manualEurRate);
  }, [initialSettings.useManualRates, initialSettings.manualUsdRate, initialSettings.manualEurRate]);

  const handleLocalSave = async () => {
    setLocalIsSaving(true);
    await onSave({
      useManualRates: useManual,
      manualUsdRate: Number(usd) || '',
      manualEurRate: Number(eur) || ''
    });
    setLocalIsSaving(false);
  };

  return (
    <div className="topbar-manual-rate-container">
      <label className="manual-rate-toggle" title="Kendi belirlediğiniz sabit kur değerlerini kullanmak için aktif edin">
        <input
          type="checkbox"
          checked={useManual}
          onChange={(e) => setUseManual(e.target.checked)}
        />
        Manuel Kur Kullan
      </label>
      {useManual && (
        <div className="manual-rate-inputs">
          <div className="manual-rate-input-group">
            <span>USD:</span>
            <input
              type="number"
              step="0.01"
              value={usd}
              onChange={(e) => setUsd(e.target.value)}
            />
          </div>
          <div className="manual-rate-input-group">
            <span>EUR:</span>
            <input
              type="number"
              step="0.01"
              value={eur}
              onChange={(e) => setEur(e.target.value)}
            />
          </div>
        </div>
      )}
      <button
        className="btn-save btn-topbar-save"
        onClick={handleLocalSave}
        disabled={localIsSaving}
        style={{ padding: '6px 15px', fontSize: '0.85rem', marginLeft: 'auto' }}
      >
        {localIsSaving ? '...' : 'Kaydet'}
      </button>
    </div>
  );
});

export default ExchangeRateSettings;
